module.exports = __webpack_public_path__ + "static/Cortland-89991c11fbb822e7309ea092433600df.png";